import styled from 'styled-components';

import CardRow from 'components/CardRow';

export const ModalFooter = styled(CardRow)`
  align-items: center;
  gap: 0 0.5rem;
  justify-content: flex-end;
`;
